import { useLocation, useSearch } from 'wouter';
import { AppHeader } from '../components/AppHeader.js';
import { DoneCard } from '../components/DoneCard.js';

export function Done(): JSX.Element {
  const [, setLocation] = useLocation();
  const search = useSearch();
  const params = new URLSearchParams(search);
  const known = parseIntOr0(params.get('known'));
  const unknown = parseIntOr0(params.get('unknown'));
  const unsure = parseIntOr0(params.get('unsure'));

  return (
    <>
      <AppHeader />
      <DoneCard
        known={known}
        unknown={unknown}
        unsure={unsure}
        onHome={() => setLocation('/')}
        onReview={() => setLocation('/review')}
      />
    </>
  );
}

function parseIntOr0(s: string | null): number {
  if (!s) return 0;
  const n = parseInt(s, 10);
  return Number.isFinite(n) && n >= 0 ? n : 0;
}
